// extracted by mini-css-extract-plugin
export default {"loading":"message_loading__9ecW5","pcWrap":"message_pcWrap__HF8-6"};